import $date from '@/services/date'
import { isEmpty } from 'lodash'

const isCacheFresh = ({
  cacheDuration,
  duractionUnits,
  lastUpdated,
  forceRefresh = false,
}) => {
  // If not being forced to refresh and it hasn't been longer than staleness threshold
  // return resource without API call

  return (
    !isEmpty(lastUpdated) &&
    !forceRefresh &&
    $date().diff(lastUpdated, duractionUnits) < cacheDuration
  )
}

export { isCacheFresh }
